import Vue from 'vue';
import notification from 'vue-notification';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './assets/style.scss';
import { HttpClient } from '@/plugins/http';
import './plugins/components';

Vue.config.productionTip = false;

Vue.use(notification);
Vue.use(HttpClient);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
